import { render } from "./FrecuentAccessComponent.vue?vue&type=template&id=6732b02a&scoped=true"
import script from "./FrecuentAccessComponent.vue?vue&type=script&lang=js"
export * from "./FrecuentAccessComponent.vue?vue&type=script&lang=js"

import "./FrecuentAccessComponent.vue?vue&type=style&index=0&id=6732b02a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6732b02a"]])

export default __exports__